import { Accordion, AccordionDetails, AccordionSummary, FormControl, FormHelperText, Grid2 } from "@mui/material";
import { ArrowDownward } from "@mui/icons-material";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialSelect from "../../../../components/MasterSelect";

const DisplayWidgetAccordion = ({
  expanded,
  onAccordionChange,
  formData,
  handleChange,
  pageMode,
  accordionSx,
  descriptionSx,
  widgetTypeOptions,  
}) => {
  return (
    <Accordion
      expanded={expanded}
      onChange={(_, isExpanded) => onAccordionChange(isExpanded ? "displayWidget" : false)}
      sx={accordionSx}
    >
      <AccordionSummary expandIcon={<ArrowDownward />}>
        <Grid2 container>
          <Grid2 size={{sm: 6, xs: 12 }}>
            <MaterialTypography
              component="span"
              variant="body2"
              fontWeight="bold"
            >
              Display & Widget
            </MaterialTypography>
            <MaterialTypography
              component="div"
              variant="caption"
              sx={descriptionSx}
            >
              Choose how the field appears in the UI and its helper text.
            </MaterialTypography>
          </Grid2>
        </Grid2>
      </AccordionSummary>

      <AccordionDetails>
        <Grid2 container spacing={1}>
          {/* widgetTypeId */}
          <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
            <MaterialTypography component="label" variant="caption" fontWeight="bold">
              Widget Type*
            </MaterialTypography>
            <MaterialSelect
              name="widgetTypeId"
              value={formData.widgetTypeId}
              onChange={handleChange}
              options={widgetTypeOptions}
              success={formData.widgetTypeIdStatus === "success"}
              error={formData.widgetTypeIdStatus === "error"}
              isDisabled={pageMode === "view"}
            />
          </Grid2>

          {/* placeholder */}
          <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
            <MaterialTypography component="label" variant="caption" fontWeight="bold">
              Placeholder
            </MaterialTypography>
            <MaterialInput
              name="placeholder"
              placeholder="e.g. Enter your name"
              type="text"
              value={formData.placeholder}
              onChange={handleChange}
              success={formData.placeholderStatus === "success"}
              error={formData.placeholderStatus === "error"}
              disabled={pageMode === "view"}
            />
            {formData.placeholderStatus === "error" && (
              <FormControl error>
                <FormHelperText>
                  Placeholder should be a minimum 1 character & maximum 50 characters long.
                </FormHelperText>
              </FormControl>
            )}
          </Grid2>

          {/* widget maxLength */}
          <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
            <MaterialTypography component="label" variant="caption" fontWeight="bold">
              Maximum Length (Widget-level)*
            </MaterialTypography>
            <MaterialInput
              name="widgetMaxLength"
              placeholder="e.g. 100"
              type="number"
              value={formData.widgetMaxLength}
              onChange={handleChange}
              success={formData.widgetMaxLengthStatus === "success"}
              error={formData.widgetMaxLengthStatus === "error"}
              disabled={pageMode === "view"}
            />
            {formData.widgetMaxLengthStatus === "error" && (
              <FormControl error>
                <FormHelperText>
                  Maximum Length should be a minimum 1 character & maximum 50 characters long.
                </FormHelperText>
              </FormControl>
            )}
          </Grid2>
        </Grid2>
      </AccordionDetails>
    </Accordion>
  );
};

export default DisplayWidgetAccordion;
